import React, { useState, useEffect, forwardRef, useImperativeHandle, useCallback } from 'react'
import './customCaret.less'

export interface CustomCaretProps {
  updateCaretPosition: () => void
}

interface Props {
  ref: React.Ref<any>
  inputRef: HTMLInputElement | null
  date?: boolean
}

const CustomCaret: React.FC<Props> = forwardRef(({ inputRef, date }: Props, ref) => {
  const [showCaret, setShowCaret] = useState(false)
  const [shadowText, setShadowText] = useState('')

  const updateCaretPosition = useCallback(() => {
    if (!inputRef) return
    const originCaretPosition = Number(inputRef.selectionStart)
    const originInputValue = inputRef.value

    if (originInputValue && originCaretPosition > 0) {
      const replaceSpacesInputValue = originInputValue.split(' ').join('I')
      setShadowText(replaceSpacesInputValue.slice(0, originCaretPosition))
    } else {
      setShadowText('')
    }
  }, [inputRef])

  useEffect(() => {
    inputRef && updateCaretPosition()
  }, [inputRef, updateCaretPosition])

  useEffect(() => {
    const interval = setInterval(() => setShowCaret((value) => !value), 500)
    return () => clearInterval(interval)
  }, [setShowCaret])

  useImperativeHandle(ref, () => {
    return { updateCaretPosition: updateCaretPosition }
  })

  return (
    <>
      {inputRef && document.activeElement === inputRef && (
        <div className="custom-caret">
          <div className="moved-container" style={{ left: -inputRef.scrollLeft }}>
            <span className={`invisible-text ${date && ' monospace'}`}>{shadowText}</span>
            {showCaret && <div className="caret"></div>}
          </div>
        </div>
      )}
    </>
  )
})

export default CustomCaret
